export { ContextChannel } from "./ContextChannel";
export { useChannel } from "./useChannel";
export type { ContextChannelClass } from "./useChannel";
export { StateBuilder } from "./StateBuilder";
export type { Model as StateBuilderModel, RelationMap, Unloaded } from "./StateBuilder";
export type { ConditionTriple, QueryDescriptor } from "./membership";

export const VERSION = "0.2.0";
